import styled from '@emotion/styled'

export const DIV = styled.div((props)=>({
    ...props.className,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: 300,
    '.sub-heading': {
        margin: '20px 0 10px'
    }
}))